import { detectDefaultCurrency } from '../OptionData/index.js';
import {
  USER_SIGN_UP,
  USER_SIGN_IN,
  GET_INITIALIZE,
  SET_SIGNUP_MEMBER,
  SET_EMAIL,
  USER_LOGGED_OUT
} from './../types.js';
const initialState = {
  user: {
    auth: false
  },
  currency: null,
  loading: true,
  errors: null
};
export default function user(state = initialState, action = {}) {
  switch (action.type) {
  case 'LOADING':
    return {
      ...state,
      loading: action.data
    };
  case USER_SIGN_IN:
    // const userInfo = action.payload.user
    // console.log("action.client : ", action.client);
    return Object.assign({}, state, {
      user: action.payload.user
      // loading: false, success: true
      // client : action.client
    });
  case GET_INITIALIZE:
    console.log('GET_INITIALIZE', action.data);
    return Object.assign({}, state, { user: action.data.user, loading: false });
  case USER_LOGGED_OUT:
    return Object.assign({}, state, { user: { auth: false } });
  case 'USER_ERROR':
    return Object.assign({}, state, { errors: action.errors, loading: false, success: false });
    case "SET_CURRENCY":
      return { ...state, currency: action.payload };
    case "SET_DEFAULT_CURRENCY":
      //remove condition if it is implemented for all users, currently it is for sales links
      return { ...state, currency: state.user.auth ? "INR" : detectDefaultCurrency() };
    
  default:
    return state;
  }
}
